import { Skeleton } from "@/components/ui/skeleton";

const GameCardSkeleton = () => {
  return (
    <div className="border border-dark-foreground/10 bg-dark-foreground/[0.02] overflow-hidden">
      {/* Image skeleton */}
      <Skeleton className="h-[420px] w-full rounded-none" />
      
      {/* Content */}
      <div className="p-8">
        {/* Title */}
        <Skeleton className="h-8 w-3/4 mb-4" />
        
        {/* Stats */}
        <div className="flex gap-4 mb-4">
          <Skeleton className="h-5 w-24" />
          <Skeleton className="h-5 w-20" />
        </div>
        
        {/* Description */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-4/6" />
        </div>
      </div>
    </div>
  );
};

export default GameCardSkeleton;
